function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.845 31.595a3.541 3.541 0 116.575-.047",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.13
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.205 32.37c-5.138-1.328-9.765-1.027-14.164 0-1.057 7.278-.83 16.605-3.54 21.245 6.982 1.151 14.06 1.21 21.245 0-2.656-4.426-2.415-14.105-3.54-21.246z",
  strokeLinejoin: "round",
  strokeWidth: 1.0003324999999998
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.51 36.795h15.226M22.041 54.1l1.77-12.878M30.008 54.5v-8.852M36.205 53.892l-1.77-10.9",
  strokeWidth: 1.0003324999999998
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.795 1.058h2.656v25.8h-2.656z",
  strokeLinejoin: "round"
}));

var SvgBroom = function SvgBroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Broom.0204c4a6.svg";
export { ForwardRef as ReactComponent };